var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Flex } from '../Flex';
var SwatchColor = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 24px;\n  width: 24px;\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  margin: 4px;\n  cursor: ", ";\n"], ["\n  height: 24px;\n  width: 24px;\n  background-color: ", ";\n  border-radius: 50%;\n  display: flex;\n  margin: 4px;\n  cursor: ", ";\n"])), function (props) { return props.color; }, function (props) { return (props.onClick ? 'pointer' : 'default'); });
var propTypes = {
    colors: PropTypes.arrayOf(PropTypes.string),
    onClick: PropTypes.func,
};
var Swatch = function (_a) {
    var colors = _a.colors, onClick = _a.onClick, props = __rest(_a, ["colors", "onClick"]);
    return (React.createElement(Flex, __assign({ flexWrap: 'wrap' }, props), colors.map(function (color, idx) { return (React.createElement(SwatchColor, { "data-testid": "".concat(idx, "-").concat(color), key: "".concat(idx, "-").concat(color), color: color, onClick: onClick ? function () { return onClick(color); } : undefined })); })));
};
Swatch.propTypes = propTypes;
Swatch.displayName = 'Swatch';
export default Swatch;
var templateObject_1;
//# sourceMappingURL=Swatch.js.map